import * as React from 'react';
export const IcPayment = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M18 3H6a3 3 0 00-3 3v12a3 3 0 003 3h12a3 3 0 003-3V6a3 3 0 00-3-3zm-3.14 7H16a1 1 0 010 2h-1.14a4 4 0 01-2.61 2.78l2.26 1.36a1 1 0 01-1.02 1.72l-5-3s-.06-.06-.09-.08a.67.67 0 01-.15-.14l-.11-.15a.999.999 0 01-.08-.18 1.18 1.18 0 010-.2L8 14v-.07a1.29 1.29 0 010-.19 1.07 1.07 0 01.07-.19v-.06c0-.06.06-.06.08-.09a.91.91 0 01.3-.26l.16-.08h.21L9 13h2a2 2 0 001.72-1H8a1 1 0 010-2h4.72A2 2 0 0011 9H8a1 1 0 010-2h8a1 1 0 110 2h-1.56c.187.312.328.649.42 1z'
      fill='currentColor'
    />
  </svg>
);
